export const isVideoAd = (ad) => {
  const type = String(ad?.mediaType || '').trim().toLowerCase();
  return type === 'video' || Boolean(ad?.videoPlaybackUrl);
};

export const getAdLibraryUrl = (ad) => {
  const url = ad?.adLibraryUrl || ad?.ctaLink || null;
  return url && String(url).trim().startsWith('http') ? String(url).trim() : null;
};

/** In-app player when API returned videoPlaybackUrl and feature flag is on. */
export const canPlayInAppVideo = (ad, playbackEnabled = true) => (
  playbackEnabled !== false && Boolean(ad?.videoPlaybackUrl)
);

/** Show play overlay on any video ad (in-app or Ad Library). */
export const shouldShowPlayButton = (ad) => (
  isVideoAd(ad) && (Boolean(ad?.videoPlaybackUrl) || Boolean(getAdLibraryUrl(ad)))
);

/** @deprecated use canPlayInAppVideo */
export const canPlayAdVideo = canPlayInAppVideo;

/** Proxied images omit referrer; direct CDN uses platform defaults. */
export const imageReferrerPolicy = (ad) => {
  if (String(ad?.mediaUrl || '').includes('/image-proxy?')) return undefined;
  if (ad?.platform === 'meta') return 'no-referrer';
  return undefined;
};
